<template>
    <div class="inline-block font-semibold border-orange border-2 rounded-lg p-2 text-center cursor-pointer"
         :class="{active: active}"
         @click="onClick"
    >
        <div>{{ width }}x{{ height }} cm</div>
        <div>Preis {{ moneyFormat(price) }}</div>
    </div>
</template>

<script>
import { moneyFormat } from "~/scripts/Pipeline/_helpers.js";

export default {
    props: ['width', 'height', 'price', 'active'],

    methods: {
        moneyFormat(value) {
            return moneyFormat(value);
        },

        onClick() {
            this.$emit('click');
        }
    }
};
</script>
